import React from 'react';
import { HISTORY_LABELS, statusMeta, formatTime } from '../../utils/kitchenTasks';

const FIELD_LABELS = { title: 'Nom', description: 'Consigne', category_name: 'Catégorie', task_date: 'Date', service: 'Service', due_time: 'Heure limite', planned_quantity: 'Quantité', unit: 'Unité', priority: 'Priorité', chef_comment: 'Commentaire chef' };

const describe = (h) => {
  const d = h.details || {};
  if (h.action === 'statut') {
    const parts = [`${statusMeta(d.from).label} → ${statusMeta(d.to).label}`];
    if (d.actual_quantity != null) parts.push(`Quantité produite : ${d.actual_quantity} ${d.unit || ''}`);
    if (d.comment) parts.push(`Commentaire : ${d.comment}`);
    if (d.reason) parts.push(`Motif : ${d.reason}`);
    return parts.join(' · ');
  }
  if (h.action === 'affectation') return `${(d.from || []).join(', ') || 'Non affectée'} → ${(d.to || []).join(', ') || 'Non affectée'}${d.auto ? ' (prise en charge)' : ''}`;
  if (h.action === 'creation') return `Statut initial : ${statusMeta(d.status).label}${d.assigned_user_names?.length ? ` · Affectée à ${d.assigned_user_names.join(', ')}` : ''}`;
  if (h.action === 'modification') return Object.entries(d).map(([k, v]) => `${FIELD_LABELS[k] || k} : ${v.from ?? '—'} → ${v.to ?? '—'}`).join(' · ');
  return '';
};

const TaskHistory = ({ history = [] }) => (
  <div className="border-t border-gray-100 pt-3 space-y-2" data-testid="task-history">
    {[...history].reverse().map((h, i) => (
      <div key={`${h.at}-${i}`} className="flex gap-3 text-sm">
        <div className="w-2 h-2 rounded-full bg-neon-pink mt-1.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-gray-900"><span className="font-semibold">{HISTORY_LABELS[h.action] || h.action}</span> <span className="text-gray-500">par {h.by_name || 'Système'} · {formatTime(h.at)}</span></p>
          {describe(h) && <p className="text-gray-600 text-xs break-words">{describe(h)}</p>}
        </div>
      </div>
    ))}
    {history.length === 0 && <p className="text-gray-400 text-sm">Aucun historique</p>}
  </div>
);

export default TaskHistory;
